import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import Stack from '@mui/material/Stack';
import * as React from 'react';
import MenuButton from '../../components/MenuButton';
import NavbarBreadcrumbs from '../../components/NavbarBreadcrumbs';
import ColorModeIconDropdown from '../../theme/ColorModeIconDropdown';

export default function LocationHeader() {
  return (
    <Stack
      direction="row"
      sx={{
        display: { xs: 'none', md: 'flex' },
        width: '100%',
        alignItems: { xs: 'flex-start', md: 'center' },
        justifyContent: 'space-between',
        maxWidth: { sm: '100%', md: '1700px' },
        pt: 1.5,
      }}
      spacing={2}
    >
      <NavbarBreadcrumbs />
      <Stack direction="row" sx={{ gap: 1 }}>
        <MenuButton showBadge aria-label="Notificações">
          <NotificationsRoundedIcon />
        </MenuButton>
        <ColorModeIconDropdown />
      </Stack>
    </Stack>
  );
} 